import { FC } from 'external/react'
import {clsx, styled} from 'external/material'

import MobileTimePicker, {MobileTimePickerProps} from './MobileTimePicker'

const StyledTimeRangePicker = styled('div')(timeRangePickerStyles as any)

type TimeRangePickerProps = {
  label: string,
  className?: string,
  minTime: MobileTimePickerProps,
  maxTime: MobileTimePickerProps
}

export const TimeRangePicker: FC<TimeRangePickerProps> = props => {
  const { label, className, minTime, maxTime} = props
  return (
    <StyledTimeRangePicker className={clsx('timerange-picker', className)}>
      <div className="label">{label}</div>
      <div className="container">
        <div className="picker">
          <MobileTimePicker {...minTime} />
        </div>
        <div className="separator">-</div>
        <div className="picker">
          <MobileTimePicker {...maxTime} />
        </div>
      </div>
    </StyledTimeRangePicker>
  )
}

function timeRangePickerStyles() {
  return {
    display: 'flex',
    flexDirection: 'column',
    '& .label': {
      fontSize: '16px', color: '#4a4a4a', alignSelf: 'flex-start'
    },
    '& .separator': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transform: 'scaleX(1.5)' 
    },
    '& .picker': {
      display: 'flex'
    },
    '& .container': {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'space-between',
      width: '100%' ,
      marginTop: 5
    }
  }
}